export const style = {
  button: {
    cursor: `pointer`,
    ':not(:first-of-type)': {
      marginLeft: `15px`
    }
  },
  reversedActive: {
    color: `white`
  },
  reversedInactive: {
    color: `#aaa`
  },
  active: {
    color: `black`
  },
  inactive: {
    color: `#ccc`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Editor/style/button.js